export default __webpack_public_path__ + "static/media/Shadow's Hood of Whispered Deeds.839ce30e.jpg";